// 菜单
export default {
    groundStationSetting: '地面站设置',
    parameterSet: '参数设置',
    deviceManagement: '设备管理',
    sharingManagement: '共享管理',
    historyPlayback: '历史回放',
    flightRecords: '飞行记录',
    historicalRecords: '历史记录',
    videoRecords: '视频记录',
    photoRecords: '照片记录',
    lpr: '识别记录',
    inspectionRecord: '检查记录',
    mobileSpectrumRecord: '手机频谱记录',
    lifeDetectionRecord: '生命探测记录',
    flightRecordDetails: '检查记录详情',
    enterpriseUsers: '企业用户信息',
    lifeStatistics: '寿命统计',
    flightRecordPlayback: '飞行记录播放',
    details_uav: '设备详情(无人机)',
    details_PTZ: '设备详情(云台)',
    details_battery: '设备详情(智能电池)',
    details_rtk: '设备详情(RTK)',
    details_simulator: '设备详情(模拟机)',
    weatherStation: '设备详情(气象站)',
    oplog: '操作日志',
    systemOperation: '系统操作',
    flightOperation: '飞行操作',
    productAftersale: '产品售后',
    modelDataManagement: '三维数据融合平台',
    positioning3Ddata: '三维数据定位',
}